/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CompactViewBox.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import CustomButtonV2 from "../common/button/CustomButtonV2";
import ImageBox from "./ImageBox";
import CustomToolTip from "../../infoButton/CustomToolTip";
import RefreshIcon from "@mui/icons-material/Refresh";
import { componentStyle } from "../../../config/appTheme";

function CompactViewBox({
  imageUrl,
  title,
  onRecreateClick,
  vehicleClass,
  projectOwner,
  trademark,
  vehiclePlatform,
  createdAt,
  updatedAt,
  status,
  onViewMore,
  architectureName,
}) {
  const formatLabel = (str) => {
    return str
      ?.toLowerCase()
      ?.split(" ")
      ?.map((word) =>
        word === "sop" ? "SOP" : word.charAt(0).toUpperCase() + word.slice(1),
      )
      ?.join(" ");
  };

  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 1,
        borderRadius: 0,
        boxShadow: 2,
        mb: 1,
      }}
    >
      {/* Column 1: Image */}
      {imageUrl && <ImageBox boxes={imageUrl || ""} />}

      {/* Column 2: Details */}
      <CardContent
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >

        <Box
          sx={{
            display: "flex",
            alignItems: "start",
            gap: 1,
          }}
        >

          <CustomToolTip
            type="string"
            length={50}
            style={{
              ...componentStyle.font.text,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "100%",

            }}
            title={`Project Title: ${title || "N/A"}`}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              {title}

            </Typography>
          </CustomToolTip>
          <span style={{ fontWeight: "bold" }}> - </span>
          <Typography length={10} style={{ fontWeight: "bold" }}>
            {architectureName}
          </Typography>
        </Box>

        <Typography
          textAlign={"start"}
          variant="subtitle2"
          color="text.secondary"
        >
          Vehicle Class: {vehicleClass || "N/A"}
        </Typography>
        <Typography
          textAlign={"start"}
          variant="subtitle2"
          color="text.secondary"
        >
          Project Owner: {projectOwner || "-"}
        </Typography>
        <CustomToolTip
          type="string"
          length={50}
          style={{
            ...componentStyle.font.text,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",

          }}
          title={`Trademark: ${trademark || "N/A"}`}
        >
          <Typography
            textAlign={"start"}
            variant="subtitle2"
            color="text.secondary"
          >
            Trademark: {trademark || "N/A"}
          </Typography>
        </CustomToolTip>
        <CustomToolTip
          type="string"
          length={50}
          style={{
            ...componentStyle.font.text,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",

          }}
          title={` Vehicle Platform:  ${vehiclePlatform || "N/A"}`}
        >
          <Typography
            textAlign={"start"}
            variant="subtitle2"
            color="text.secondary"
          >
            Vehicle Platform: {vehiclePlatform || "N/A"}
          </Typography>
        </CustomToolTip>

        <Typography
          textAlign={"start"}
          variant="subtitle2"
          color="text.secondary"
        >
          Created At: {createdAt || "N/A"}
        </Typography>
      </CardContent>

      {/* Column 3: Action + Status */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 3,
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          <Box sx={{ mt: 0.5, cursor: "pointer" }} onClick={onRecreateClick}>
            <RefreshIcon />
          </Box>
          <CustomButtonV2
            type="submit"
            btnName="View More"
            handleOnClick={onViewMore}
          />
        </Box>
        <Typography variant="subtitle2" fontWeight="bold" color="green">
          {status || "ACTIVE PRE SOP"}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Updated At: {updatedAt || "N/A"}
        </Typography>
      </Box>
    </Card>
  );
}

export default CompactViewBox;
